import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createParcours, type ParcoursDto } from "../api/parcoursApi";
import { queryKeys } from "../lib/queryKeys";

export function useCreateParcours() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: ParcoursDto) => createParcours(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.parcours.all });
    },
  });
}
